import { render, staticRenderFns } from "./RoundPatrolInspection.vue?vue&type=template&id=f118467a&"
import script from "./RoundPatrolInspection.vue?vue&type=script&lang=js&"
export * from "./RoundPatrolInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports